module.exports = __webpack_public_path__ + "img/traeesaexpress.eead5675.png";